import React from 'react';
import './HUD.css';

export default function Scoreboard({ gs, myId }) {
  const matchPts = gs.game_scores || [0, 0];
  const roundPts = gs.team_points || [0, 0];
  const myTeam = myId >= 0 ? myId % 2 : 0;
  const oppTeam = 1 - myTeam;

  const bidWinnerTeam = gs.bid_winner >= 0 ? gs.bid_winner % 2 : -1;
  const bid = gs.current_bid || 0;
  const totalPoints = gs.mode === '56' ? 56 : 28;

  const renderRoundScore = (teamId) => {
    const current = roundPts[teamId];
    // If no bid is won yet, just show the current captured points
    if (bidWinnerTeam < 0 || bid === 0) return current;

    const isBiddingTeam = teamId === bidWinnerTeam;
    // The defending team needs (Total - Bid + 1) to break the contract
    const target = isBiddingTeam ? bid : (totalPoints - bid + 1);

    return (
      <div className="score-container">
        <span className="current-pts">{current}</span>
        <span className="target-divider">/{target}</span>
      </div>
    );
  };

  return (
    <div className="hud-panel combined-scoreboard">
      
      {/* Left Side: Match Score */}
      <div className="score-section">
        <div className="hud-header">MATCH</div>
        <div className="hud-row my-team">
          <span>Us</span> <span className="hud-val">{matchPts[myTeam]}</span>
        </div>
        <div className="hud-row opp-team">
          <span>Them</span> <span className="hud-val">{matchPts[oppTeam]}</span>
        </div>
      </div>

      {/* Subtle Vertical Divider */}
      <div className="score-divider" />

      {/* Right Side: Round Score */}
      <div className="score-section">
        <div className="hud-header">ROUND</div>
        <div className="hud-row my-team">
          <span>Us</span> <span className="hud-val">{renderRoundScore(myTeam)}</span>
        </div>
        <div className="hud-row opp-team">
          <span>Them</span> <span className="hud-val">{renderRoundScore(oppTeam)}</span>
        </div>
      </div>

    </div>
  );
}